import { Menu, MenuItem, TextField } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { automation } from "@common-reducers/AutomationReducer";
import { selectNumberColumns } from "@common-reducers/AutomationsSelectors";
import { getSelectedBoardId } from "@common-reducers/BoardsSelectors";
import { useAppDispatch, useAppSelector } from "@common-reducers/hooks/store.hook";
import { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import AddAndRemove from '../add-and-remove';
import PickerColumn from "../dropdowns/column-dropdown";
import { StyledTextField, errorStyle, setCurrentAction, buttonStyle } from "../automations-helper";
import AutomationButton from "../automation-button";


const IncreaseOrDecreaseAction = ({ index }: { index: number }) => {
    const dispatch = useAppDispatch()
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [columnName, setColumnName] = useState<string>('number');
    const [optionName, setMathOption] = useState<string>('increase');
    const [amount, setAmount] = useState<string>('value');
    const [dropdown, setDropdown] = useState<string>('');
    const prefix = index === 0 ? 'Then' : 'and then'
    const actions = useAppSelector((state) => state.AutomationReducer.actions);
    const boardId = useAppSelector((state) => getSelectedBoardId(state))
    const filteredColumns = useAppSelector((state) => selectNumberColumns(state, boardId));
    const attemptedSubmission = useAppSelector((state) => state.AutomationReducer.attemptedSubmission);
    const validationStates = useAppSelector((state) => state.AutomationReducer.validationStates);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>, dropdownOption: string) => {
        setAnchorEl(event.currentTarget);
        setDropdown(dropdownOption);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };


    useEffect(() => {
        if (actions) {
            const selectedColumnId = actions[index].columnId;
            const column = filteredColumns.find(item => item.id === selectedColumnId);
            setColumnName(column?.name ?? "number");
            setMathOption(actions[index]?.mathOption?.toString() ?? "increase");
            setAmount(actions[index]?.numberAmount?.toString() ?? "")
            dispatch(automation.fieldValidityChanged({ component: 'IncreaseOrDecreaseAction', index, field: 'columnId', isValid: !!selectedColumnId }));
            dispatch(automation.fieldValidityChanged({ component: 'IncreaseOrDecreaseAction', index, field: 'mathOption', isValid: !!actions[index]?.mathOption }));
            dispatch(automation.fieldValidityChanged({ component: 'IncreaseOrDecreaseAction', index, field: 'numberAmount', isValid: !!actions[index]?.numberAmount }));
        }
    }, [actions, dispatch, filteredColumns, index]);


    const handleColumnChange = (id: string, name: string) => {
        dispatch(automation.setActions(setCurrentAction(actions, index, { actionType: actions[index].actionType, columnId: id })));
        setColumnName(name);
        handleClose();

    };

    const clickedOption = (option: string) => {
        dispatch(automation.setActions(setCurrentAction(actions, index, { actionType: actions[index].actionType, mathOption: option })));
        setMathOption(option)
        handleClose();
    };

    const handleNumberChange = (event: React.FocusEvent<HTMLInputElement>) => {
        dispatch(automation.setActions(setCurrentAction(actions, index, { actionType: actions[index].actionType, numberAmount: Number(event.target.value?.replaceAll(',', '')) })));
    }

    return (
        <Stack>
            <Stack key={index} sx={{ fontSize: "24px" }} direction="row" alignItems={"flex-start"} justifyContent={"space-between"}>
                <Box>
                    {prefix}
                    <AutomationButton
                        componentName='IncreaseOrDecreaseAction'
                        index={index}
                        option='mathOption'
                        label={optionName}
                        handleClick={(e) => handleClick(e, 'columnOptions')}
                        validationStates={validationStates}
                        attemptedSubmission={attemptedSubmission}
                    />

                    <AutomationButton
                        componentName='IncreaseOrDecreaseAction'
                        index={index}
                        option='columnId'
                        label={columnName}
                        handleClick={(e) => handleClick(e, 'pickerColumn')}
                        validationStates={validationStates}
                        attemptedSubmission={attemptedSubmission}
                    />

                    <NumericFormat
                        value={amount ?? ""}
                        onBlur={handleNumberChange}
                        allowNegative
                        decimalSeparator="."
                        allowLeadingZeros
                        customInput={StyledTextField}
                        thousandSeparator=","
                        label="Some amount"
                        variant="standard"
                        sx={{
                            marginTop: '8px',
                            ...buttonStyle,
                            ...(attemptedSubmission && validationStates[`IncreaseOrDecreaseAction_${index}`]?.numberAmount === false ? errorStyle : {}),
                        }}
                    />
                </Box>
                <AddAndRemove elements={actions} index={index} type={"actions"}  componentName="IncreaseOrDecreaseAction"/>
            </Stack>

            {dropdown === 'pickerColumn' && (
                <PickerColumn
                    anchorEl={anchorEl}
                    handleClose={handleClose}
                    filteredColumns={filteredColumns}
                    handleColumnChange={handleColumnChange}
                />)}

            {dropdown === 'columnOptions' && (
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >
                    <MenuItem onClick={() => clickedOption("Increase")}>Increase</MenuItem>
                    <MenuItem onClick={() => clickedOption("Decrease")}>Decrease</MenuItem>
                </Menu>)}

        </Stack>


    )
}
export default IncreaseOrDecreaseAction